import { render, staticRenderFns } from "./admin_rcln.vue?vue&type=template&id=183e43a2&scoped=true"
import script from "./admin_rcln.vue?vue&type=script&lang=js"
export * from "./admin_rcln.vue?vue&type=script&lang=js"
import style0 from "./admin_rcln.vue?vue&type=style&index=0&id=183e43a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e43a2",
  null
  
)

export default component.exports